import { memo } from "react";

import { styled } from "@mui/material/styles";

import { Button } from "@mui/material";

import PropTypes from "prop-types";
import { createStructuredSelector } from "reselect";

import { connect } from "react-redux";

import { compose } from "redux";

import DiverstImg from "components/Shared/DiverstImg";
import { selectEnterprise } from "containers/Shared/App/selectors";
import comLogoPrimary from "images/communitycliq-logo-purple.svg";
import comLogo from "images/communitycliq-logo.svg";
import { useGetLogoBranding } from "generated/api/platform-branding/platform-branding";

const PREFIX = "index";

const classes = {
  button: `${PREFIX}-button`,
  logoPadding: `${PREFIX}-logoPadding`,
  logo: `${PREFIX}-logo`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled("div")(() => ({
  [`& .${classes.button}`]: {
    display: "block",
    color: "#FFFFFF",
  },

  [`& .${classes.logoPadding}`]: {
    paddingTop: 5,
    paddingBottom: 5,
    maxWidth: "100%",
  },

  [`& .${classes.logo}`]: {
    maxWidth: "100%",
  },
}));

export function Logo(props) {
  const { ...rest } = props;

  const currentURLWithoutPath = `${window.location.protocol}//${window.location.host}`;

  const { data: theme } = useGetLogoBranding({
    query: { gcTime: Infinity, staleTime: Infinity },
  });

  let isDefault = true;
  let logo = props.coloredDefault ? comLogoPrimary : comLogo;

  let logoRedirectUrl = (
    theme?.logoRedirectUrl || currentURLWithoutPath
  ).toLowerCase(); // Defaults to current URL without path

  const logoData = props.isSessionLogo
    ? theme?.loginScreenLogoUrl || theme?.logoUrl
    : theme?.logoUrl;

  if (logoData) {
    logo = logoData;
    isDefault = false;
  }

  // To prevent odd append redirects, add 'https://' to the URL unless the URL is a relative path,
  // or already has the protocol
  if (
    logoRedirectUrl &&
    !logoRedirectUrl.startsWith("/") &&
    !logoRedirectUrl.startsWith("https://") &&
    !logoRedirectUrl.startsWith("http://")
  ) {
    logoRedirectUrl = `https://${logoRedirectUrl}`;
  }

  const alt = props.isSessionLogo ? theme?.browserTitle : "";

  const imageComponent = (
    <DiverstImg
      // If it's default add some bottom padding as the SVGs have no padding
      className={isDefault ? classes.logoPadding : classes.logo}
      data={logo}
      alt={alt}
      naturalSrc={!logoData}
      {...rest}
    />
  );

  if (props.withLink && logoRedirectUrl) {
    return (
      <Button
        onClick={() => {
          window.location.href = logoRedirectUrl;
        }}
        className={classes.button}
      >
        {imageComponent}
      </Button>
    );
  }

  return <Root>{imageComponent}</Root>;
}

Logo.propTypes = {
  dispatch: PropTypes.func,
  className: PropTypes.string,
  enterprise: PropTypes.object,
  coloredDefault: PropTypes.bool,
  withLink: PropTypes.bool,
  imgClass: PropTypes.string,
  alt: PropTypes.string,
  isSessionLogo: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  enterprise: selectEnterprise(),
});

const withConnect = connect(mapStateToProps);

export default compose(memo, withConnect)(Logo);
